import { api } from 'app/config/apiConfig';
import { sortFloorsByOrder } from '../lib/sortFloorsByOrder';
import { Floor } from '../model/types';

export const getFloorsByWarehouseIdApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFloorsByWarehouseId: build.query<Floor[], Nullable<string | undefined>>({
      query: (warehouseId) => ({
        url: `warehouses/${warehouseId}/floors`,
      }),
      transformResponse: (response: Floor[]): Floor[] => sortFloorsByOrder(response),
    }),
  }),
});

export const { useGetFloorsByWarehouseIdQuery } = getFloorsByWarehouseIdApi;
